export default __webpack_public_path__ + "static/media/RS.e810047e.svg";